import axios from "axios";
import { COREAPI_ENDPOINTS } from "../../config";

export async function getPois() {
  return await axios.get(COREAPI_ENDPOINTS.URL + COREAPI_ENDPOINTS.PATH_POI);
}
